import { default as styled } from 'styled-components';

export const Instruction = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: ${(props) => props.theme.colors.oxfordBlue[100]};
  background: ${(props) => props.theme.colors.aeroBlue[100]};
  padding: 0.75em;
  border-radius: 0.325em;
`;
